import authFetch from './fetch';

export const routes = {
  deliveryTypePath: (dispatcherTerminal) => `/api/lookup/deliverytypes${dispatcherTerminal ? '?region=' + dispatcherTerminal : ''}`,
  nextStepsPath: () => '/api/lookup/lcnextsteps',
};

export const fetchDeliveryTypes = (dispatcherTerminal) => authFetch.get(routes.deliveryTypePath(dispatcherTerminal));

export const fetchNextSteps = () => authFetch.get(routes.nextStepsPath());
